import React, { useCallback, useEffect } from 'react';
import { useRouteMatch } from 'react-router';
import { Box } from '@common-fe/common-fe';

import { PERMISSIONS, ROUTES } from '@/common';
import EmployerDashboardContainer from '@/modules/AccountUsageDashboard';
import { useHistory } from '@/modules/core';
import { Access } from '@/modules/core/components';
import { useSidebarStore } from '@/modules/core/components/Sidebar/store/useSidebarStore';
import Topbar from '@/modules/core/components/Topbar/Topbar';
import theme from '@/styles/theme';

const EmployerDashboardPage = () => {
  const {
    params: { planId, planYear },
  } = useRouteMatch<{ planId: string; planYear: string }>();

  const { setPinned, setMinify } = useSidebarStore();

  useEffect(() => {
    setMinify(true);
    setPinned(false);

    return () => {
      setMinify(false);
      setPinned(true);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const history = useHistory();
  const goHome = useCallback(() => history.push(ROUTES.HOME), [history]);

  return (
    <Access
      accessRequirements={[
        {
          permission: PERMISSIONS.VIEW_PROFILE,
        },
      ]}
      accessDeniedAction={goHome}
    >
      <Box width="100%" margin={{ top: '0' }} height="fit-content">
        <Topbar />
        <Box align="center" pad={{ bottom: 'spacing72' }}>
          <Box width={theme.defaultContentWidth}>
            <Box pad={{ top: 'spacing24' }}>
              <EmployerDashboardContainer planId={planId} planYearId={planYear} />
            </Box>
          </Box>
        </Box>
      </Box>
    </Access>
  );
};

export default EmployerDashboardPage;
